import WINDOW from "../../utils/window";
import onRaf from "./on-raf";

const startRaf = () => {
  if (!WINDOW.get("raf-running")) {
    WINDOW.set("raf-running", true);

    onRaf();
  }
};

export default startRaf;
